/*
 * @Descripttion:
 * @version:
 * @Author: 苏
 * @email: 1373842098@qq.com
 * @Date: 2022-09-13 14:53:45
 * @LastEditors: linxi
 * @LastEditTime: 2024-12-19 14:41:21
 */
import { Col, Divider, Popover, Row, Table, Tooltip } from 'antd'
import moment from 'moment'
import React, { useContext } from 'react'
import {
  getRecipeCategoryName,
  RecipeCategory,
  RecipeStatus,
} from '../../../models/recipe'
import { ThemeContext } from '../../../theme/ThemeContext'
import styles from './TcmCases.module.css'
import { useSelector } from 'react-redux'
import { selectSettings } from '../../user/setting/settingSlice'
import { Checks } from '../../../models/setting'

interface HistoryContentProps {
  v: any
}

export const HistoryContent = ({ v }: HistoryContentProps) => {
  const theme = useContext(ThemeContext)
   const groupList = v?.groupList?.map((group: any) => {
        const list = v?.itemList?.filter((item: any) => item?.recipeGroupId == group.id);
        return {
          ...group,
          groupItemList: list
        };
  });

  const settings = useSelector(selectSettings)

  // 新老目录展示方式 (老目录没有区分药品类别/无型号)
  const getProcuctInfo = (item: any) => {
    const name = item.name ? item.name : '-'
    const spec = item.spec ? item.spec : '-'
    const accountUnit = item.accountUnit ? item.accountUnit : '-'
    const materialsCategory = item.materialsCategory
    const packSpec = item.packSpec ?  item.packSpec : '-'
    const doseCategory = item.doseCategory ? item.doseCategory : '-'
    const tenantSupplierName = item.tenantSupplierName ? '（' + item.tenantSupplierName + '）'  : ''
    const model = item.model ? '/' + item.model : ''

    if (item?.drugType == 1) { //诊疗
      return name + '/' + accountUnit
    } else {
      if (settings?.[Checks.MLKG] == 1) {
        if (materialsCategory == '0') {
          // 生产厂家 + 包装规格 + 剂型
          return name + tenantSupplierName + '/' + packSpec + '/' + doseCategory
        } else if (materialsCategory == '1' || materialsCategory == '2') {
          // 生产厂家 + 包装规格 + 型号
          return name + tenantSupplierName + '/' + packSpec + model
        } else {
          // 生产厂家 + 包装规格
          return name + tenantSupplierName + '/' + packSpec
        }
      } else {
        if (materialsCategory == '0') {
          // 生产厂家 + 包装规格 + 剂型
          return name + tenantSupplierName + '/' + packSpec + '/' + doseCategory
        } else if (materialsCategory == '1' || materialsCategory == '2') {
          // 生产厂家 + 规格 + 型号
          return name + tenantSupplierName + '/' + spec + model
        } else {
          // 生产厂家 + 规格
          return name + tenantSupplierName + '/' + spec
        }
      }
    }
  }

  return (
    <div>
      {v?.category == 15 ? <>
        {groupList?.length ? <>
          <Divider />
          <Row>
            {getRecipeCategoryName(v.category)}
            {v?.state === RecipeStatus.Returned && '（已退费）'}
            {v?.state === RecipeStatus.ToSettle && '（未结算）'}
            {v?.state === RecipeStatus.Unknown && '（未结算）'}
            {v?.state === RecipeStatus.Settled && '（已结算）'}
          </Row>
        </> : <></>}

        {groupList?.map((v: any, i: number) => (
          <>
            <Row key={i}>
              <span style={{ margin: '0 6px 0 0 ' }}>{`第${i + 1}组`}</span>
              <span style={{ margin: '0 6px 0 10px ' }}>{v?.groupTip + '帖'}</span>
            </Row>
            <Row gutter={[4, 4]}>
              {v?.groupItemList.map((el: any, i: number) => (
                <Popover
                  key={i}
                  overlayClassName={styles.popverContent}
                  zIndex={999999}
                  placement='bottom'
                  content={
                    <>
                      <div>
                        {getProcuctInfo(el)}
                      </div>
                    </>
                  }
                >
                  <Col span={8} key={i} style={{ cursor: 'pointer', color: '#666' }}>
                    {el.name} {el.countPerTip}
                    {el.splitTag ? el.splitUnit : el.accountUnit}
                  </Col>
                </Popover>
              ))}
            </Row>
          </>
        ))}

      </> : <>
        {v.itemList.length ? (
          <>
            {/* <Divider /> */}
            <Row style={{ padding: '6px 0', borderTop: '1px dashed #ccc', marginTop: '6px', color: '#101010' }} justify='space-between'>
              <Col>
                {getRecipeCategoryName(v.category)}
                <span>{v.category == 3 ? v?.tip + '帖' : ''}</span>
                {v?.state === RecipeStatus.Returned && '（已退费）'}
                {v?.state === RecipeStatus.ToSettle && '（未结算）'}
                {v?.state === RecipeStatus.Unknown && '（未结算）'}
                {v?.state === RecipeStatus.Settled && '（已结算）'}
              </Col>
              <Col>￥{v?.amount?.toFixed(2)}</Col>
            </Row>
            {v.category == RecipeCategory.Tcm ||
              v.category === RecipeCategory.TcmGranules ||
              v.category === RecipeCategory.TcmApply ? (
              <Row gutter={[4, 4]}>
                {v.itemList.map((el: any, i: number) => (
                  <Popover
                    key={i}
                    overlayClassName={styles.popverContent}
                    zIndex={999999}
                    placement='bottom'
                    content={
                      <>
                        <div>
                           {getProcuctInfo(el)}
                        </div>
                      </>
                    }
                  >
                    <Col span={8} key={i} style={{ cursor: 'pointer', color: '#666'}}>
                      {el.name} {el.countPerTip}
                      {el.splitTag ? el.splitUnit : el.accountUnit}
                    </Col>
                  </Popover>
                ))}
              </Row>
            ) : (
              v.itemList?.map((m: any, index: number) => (
                <Row 
                  justify='space-between' 
                  key={m.id}
                  style={{ color: '#666', display: 'flex', flexWrap: 'nowrap', alignItems: 'center' }}
                >
                  <Popover
                    key={index}
                    overlayClassName={styles.popverContent}
                    zIndex={999999}
                    placement='bottom'
                    content={
                      <>
                        <div>
                         {getProcuctInfo(m)}
                        </div>
                      </>
                    }
                  >
                    <Col style={{ flex: 1, minWidth: 0, marginRight: '8px' }}>{m.name}</Col>
                  </Popover>
                  <Col style={{ flex: '0 0 auto', whiteSpace: 'nowrap' }}>
                    {m.drugCount}{m.splitTag ? m.splitUnit : m.accountUnit}
                  </Col>
                </Row>
              ))
            )}
          </>
        ) : (
          ''
        )}
      </>}
    </div>
  )
}
